module.exports = __webpack_public_path__ + "img/cash_nl2.59675072.png";